import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { AuthenticationLayoutComponent } from './core/authentication-layout/authentication-layout.component';
import { AdminLayoutComponent } from './core/admin-layout/admin-layout.component';
import { AppRoutingModule } from './app.routing';
import { HeaderComponent } from './core/header/header.component';
import { SidenavComponent } from './core/sidenav/sidenav.component';
import { SidebarModule } from 'ng-sidebar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './shared';
import { UtilService } from './shared/services/util.service';
import { dateFormat } from './shared/services/dateFormat';
import { DatexPipe } from './shared/services/DatexPipe';
import { HeaderService } from './shared/services/header.service';
import { FooterComponent } from './core/footer/footer.component';
import { MessageServices } from './shared/services/message.services';
import { MessageComponent } from './shared/message/message.component';
import { StatusServices } from './shared/services/status.services';
import { LabelServices } from './shared/services/label.services';
import { MoreInfoService } from './shared/services/moreinfo.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { ApiService } from './shared/services/api.service';
import { OrderModule } from 'ngx-order-pipe';


@NgModule({
  declarations: [
    AppComponent,
    AuthenticationLayoutComponent,
    AdminLayoutComponent,
    HeaderComponent,
    SidenavComponent,
    FooterComponent,
    MessageComponent,
    DatexPipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    SidebarModule.forRoot(),
    // NgbModule.forRoot(),
    NgbModule.forRoot(),
    NgxSpinnerModule,
    OrderModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  providers: [
    AuthGuard, UtilService, ApiService, dateFormat, DatexPipe, HeaderService, FooterComponent, MessageServices, StatusServices, LabelServices, MoreInfoService,
    BnNgIdleService, HeaderComponent, OrderModule
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
